var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"product-banner"},on:{"click":_vm.scrollToListProduct}},[_c('b-img',{attrs:{"src":_vm.banner1,"fluid":"","alt":"Product banner"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }